import { TrackingMetaData } from '../../../../domains/CustomSection'
import GenericContent from '../../../../domains/GenericContent'
import TrackingEvent from '../../tracking-event'

export const getClickEvent = (
  tracking_id: string,
  content_container_type?: string,
  content_container_name?: string,
  element_position?: number,
  display_title?: string,
  tracking_meta_data?: TrackingMetaData,
) => {
  const clickEvent = new TrackingEvent(TrackingEvent.TRACKING_BROWSER_EVENT_TYPES.CLICK, {
    trackingId: tracking_id,
    contentContainerType: content_container_type,
    contentContainerName: content_container_name,
    elementPosition: element_position,
    displayTitle: display_title,
    trackingMetaData: tracking_meta_data,
  })

  return clickEvent
}

export const getVisibleEvent = (
  tracking_id: string,
  content_container_type?: string,
  content_container_name?: string,
  id?: string,
  genericContents?: GenericContent[],
  element_position?: number,
  display_title?: string,
  tracking_meta_data?: TrackingMetaData,
) => {
  const visibleEvent = new TrackingEvent(TrackingEvent.TRACKING_BROWSER_EVENT_TYPES.VISIBLE, {
    trackingId: tracking_id,
    contentContainerType: content_container_type,
    contentContainerName: content_container_name,
    id: id,
    genericContents: genericContents,
    elementPosition: element_position,
    displayTitle: display_title,
    trackingMetaData: tracking_meta_data,
  })

  return visibleEvent
}
